<form (ngSubmit)="handleSave()" class="notification-form">
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Notifications</span>
      <h3>Preference Center</h3>
      <p>
        Choose how your business receives operational alerts, reminders, and
        account updates.
      </p>
    </div>

    <div class="notification-list">
      <article
        *ngFor="let group of notificationSettings"
        class="notification-row"
      >
        <div class="notification-copy">
          <strong>{{ group.label }}</strong>
          <span>{{ group.description }}</span>
        </div>

        <div class="channel-grid">
          <label
            class="channel-card"
            *ngFor="let type of group.channels"
            [class.is-active]="type.checked"
          >
            <div>
              <strong>{{ type.label }}</strong>
              <span>{{ getChannelDescription(type.key) }}</span>
            </div>

            <glo-toggle [(value)]="type.checked"></glo-toggle>
          </label>
        </div>
      </article>
    </div>
  </section>

  <div class="form-footer">
    <button type="button" class="light-btn" (click)="getUserDetails()">
      Cancel
    </button>

    <button type="submit" class="dark-btn">Save</button>
  </div>
</form>
